import React from 'react'
import { useTranslation } from 'react-i18next'

import StartEndDateRangeFields from '../../../../../../../../../ReusableFormFields/StartEndDateRangeFields'
import FieldLabelWrapper from '../../../../../../../../../../features/components/Form/FieldLabelWrapper'

import useDrawerFormStyles from '../../../../../../../../../../styles/common/drawerForms'
import useStyles from './styles'

const CampaignDatesSection = ({ formik }) => {
  const drawerFormClasses = useDrawerFormStyles()
  const classes = useStyles()

  const { t } = useTranslation()

  return (
    <section className={drawerFormClasses.section}>
      <h3 className={drawerFormClasses.sectionTitle}>{t('Campaign Dates')}</h3>
      <p>
        {t(
          'Please enter the start and end date for all campaigns created under this right. If a campaign is created after the start date set below, the campaign creation date will be used.'
        )}
      </p>
      <FieldLabelWrapper label={t('Campaign Dates')}>
        <StartEndDateRangeFields formik={formik} dateRangeClassName={classes.dateRange} />
      </FieldLabelWrapper>
    </section>
  )
}

export default CampaignDatesSection
